<template>

    <div
        :class="{'search-wrapper':true, 'search-open': opened}"
    >
        <div class="search-input">
            <input
                ref="inputElement"
                type="text"
                class="form-control"
                :placeholder="lang('all.zoek_naar_producten')"
                v-model="searchvalue"
                @keydown="search"
                @keydown.enter="fireSearch"
                @keydown.esc="close"
            />
            <small class="form-text text-muted">{{ lang('all.voer_minimaal_1_karakter_in_of_druk_op_enter_om_di') }}</small>
        </div>

        <div class="search-error text-danger mt-4" v-if="error === true">
            <i class="mdi mdi-alert text-danger"></i>
            {{ lang('all.er_is_een_fout_opgetreden_bij_het_zoeken_probeer_h') }}
        </div>

        <div class="search-throttled mt-4" v-if="throttled === true">
            <i class="mdi mdi-alert text-danger"></i>
            {{ lang('all.niet_zo_snel') }}
            <span v-if="throttle.seconds > 0">
                {{ lang('all.probeer_het_over_seconde_nogmaals', {'%seconds%': throttle.seconds}) }}
            </span>
        </div>

        <div class="search-results mt-4" v-if="searched === true">
            <div
                v-if="results.length === 0"
                class="no-results"
            >
                <p>{{ lang('all.er_zijn_geen_resultaten_gevonden') }}</p>
            </div>
            <div
                v-for="result in results"
                class="search-result"
                @click="openResult(result)"
            >
                <div class="row">
                    <div class="col-4">
                        <inertia-link
                            :href="result.url"
                            @click="close"
                        >
                            <img
                                :src="result.imageurl"
                                :alt="result.name"
                            />
                        </inertia-link>
                    </div>
                    <div class="col-8">
                        <inertia-link
                            :href="result.url"
                            @click="close"
                        >{{ result.name }}</inertia-link>
                        <p>{{ result.subtitle }}</p>
                    </div>
                </div>
            </div>
        </div>

        <button
            class="close-search"
            @click="close"
        >
            <i class="mdi mdi-close"></i>
            <span class="sr-only">{{ lang('all.zoeken_sluiten') }}</span>
        </button>
    </div>

</template>

<script>

import axios from 'axios';
import moment from 'moment';

export default {

    computed: {
        canSearch() {
            return this.searching === false &&
                this.searchvalue !== '' &&
                this.searchvalue !== this.lastsearch &&
                (
                    this.throttle.reset === 0 ||
                    this.throttle.reset < parseInt(moment().unix())
                )
        },

        getSearchData() {
            return {
                searchvalue:this.searchvalue,
            }
        },
    },

    data() {
        return {
            opened:false,
            results:[],
            lastsearch:'',
            searched:false,
            searching:false,
            searchvalue:'',

            error:false,
            throttled:false,
            throttle: {
                reset:0,
                seconds:0,
            },
            throttleTicktockIntval:null,
        }
    },

    methods: {
        close() {
            this.opened = false;
        },
        open() {
            this.opened = true;
            this.$nextTick(() => {
                this.$refs.inputElement.focus();
            })
        },

        search: _.debounce(function () { this.fireSearch(); }, 350),
        fireSearch() {
            if (!this.canSearch) {
                return;
            }

            this.searching = true;
            this.lastsearch = JSON.parse(JSON.stringify(this.searchvalue));

            this.error = false;
            this.throttled = false;
            this.throttle.retry = 0;
            this.throttle.reset = 0;

            axios.get(this.route('api.v1.search.index'), {params:this.getSearchData})
                .then(resp => {
                    this.results = resp.data.data;
                    this.searched = true;
                })
                .catch((err) => {
                    if (err.response.status === 429) {
                        //throttling
                        this.throttled = true;

                        if (err.response.headers['x-ratelimit-reset']) {
                            this.throttle.reset = parseInt(err.response.headers['x-ratelimit-reset']);
                            this.throttle.seconds = this.throttle.reset - moment().unix();
                        }

                        this.startThrottleTicktock();

                    } else {
                        this.error = true;
                        this.$snotify.error(this.lang('snotify.search_error'));
                    }
                })
                .finally(() => this.searching = false);
        },

        openResult(result) {
            this.close();
            this.$inertia.visit(result.url);
        },

        throttleTicktock() {
            if (this.throttle.reset === 0) {
                this.stopThrottleTicktock();
                return;
            }

            let seconds = this.throttle.reset - moment().unix();

            if (seconds < 1) {
                this.stopThrottleTicktock();
                this.throttled = false;
                this.throttle.seconds = 0;
                this.throttle.reset = 0;
                return;
            }

            this.throttle.seconds = seconds;
        },

        startThrottleTicktock() {
            this.throttleTicktockIntval = setInterval(this.throttleTicktock.bind(this), 1000);
        },

        stopThrottleTicktock() {
            clearInterval(this.throttleTicktockIntval);
        },
    },

    name:'Search',

}

</script>
